module.exports = __webpack_public_path__ + "static/media/kick_02.f5e08c6e.wav";